import React from 'react';
import UsersScreen from '../Users/UsersScreen';

const UsersTab: React.FC = () => {
  return (
    <div className="section section-users">
      <UsersScreen />
    </div>
  );
};

export default UsersTab;
